import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "jdm_recently_viewed_v1";
const MAX_ITEMS = 8;

const readStore = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const writeStore = (ids) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(ids)); } catch { /* ignore */ }
  window.dispatchEvent(new Event("jdm:recently-viewed-updated"));
};

export const useRecentlyViewed = () => {
  const [ids, setIds] = useState(readStore);

  useEffect(() => {
    const refresh = () => setIds(readStore());
    window.addEventListener("jdm:recently-viewed-updated", refresh);
    window.addEventListener("storage", refresh);
    return () => {
      window.removeEventListener("jdm:recently-viewed-updated", refresh);
      window.removeEventListener("storage", refresh);
    };
  }, []);

  const recordView = useCallback((productId) => {
    if (!productId) return;
    const current = readStore();
    const next = [productId, ...current.filter((id) => id !== productId)].slice(0, MAX_ITEMS);
    writeStore(next);
  }, []);

  return { ids, recordView };
};
